import { TENANT_BRANDING } from './branding.js';

export const TENANT_CONFIG = {
  ...TENANT_BRANDING,
  billingPlan: 'enterprise',
  // ProVer es un tenant/cliente. No define módulos: consume los módulos publicados por QorIAX SaaS.
  moduleEntitlements: {
    dashboard: { enabled: true, label: 'Centro de Control' },
    reception: { enabled: true, label: 'Recepción y Turnos' },
    appointments: { enabled: true, label: 'Turnos' },
    specialists: { enabled: true, label: 'Profesionales' },
    multichat: { enabled: true, label: 'MultiChat' },
    patient_portal: { enabled: true, label: 'Portal Paciente' },
    tenant_management: { enabled: true, label: 'Gestión del Tenant' }
  },
  channels: {
    whatsapp: { enabled: true, instance: 'qoriax-prover' },
    web_chat: { enabled: true }
  }
};

export default TENANT_CONFIG;
